import React from "react";
import { dispatch } from '@rematch/core';
import { toastr } from 'react-redux-toastr';
import { Image, Grid, Icon, Button, Modal, List, Accordion, Card, Popup } from "semantic-ui-react";
import { withRouter } from "react-router";
import CreateInitiativeSteps from './Steps';
import BreadCrumbs from './../../Drive/cards/Breadcrumbs'
import Labels from './../../../../common/Labels';
import momentDateAndTime from "./../../../../../helpers/momentDateAndTime";
import extensionPreview from "../../../../../helpers/extensionPreview"
import LoadingComponent from "../../../../common/LoadingComponent";
import ImageAvater from "../../../../drive/Components/ImageAvater";
import DailyUpdateCheckBox from "../../Drive/cards/DailyUpdateCheckBox";
import noImage from '../../../../../images/common/broken-image.png'
import brokenUserImg from '../../../../../images/common/user-avatar.png'
import _ from 'lodash';
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import MetaDatareadonlyView from "../../../../drive/FormBuilder/MetaDataReadOnlyView";
let activityCount;
let totalCompletedCount;
let totalInProgressCount;
let totalIssueCount;
let totalOnHoldCount;
class ReviewAndStart extends React.Component {
    constructor(props) {

        super(props);
        this.state = {
            open: true,
            activeIndex: 0
        }
        this.getTeam = this.getTeam.bind(this);
    }
    componentWillReceiveProps() {
        if ((!this.props.teamList || this.props.teamList.length === 0) && (this.props.selectedDataById.teamId && this.props.selectedDataById.teamId !== this.props.selectedOrganisation.id)) {
            let payload = {};
            payload.id = this.props.selectedOrganisation.id;
            payload.teamlist = true;

            dispatch.initiatives.getTeamsUnderManager(payload);
        }

        if (this.props.selectedDataById && this.props.selectedDataById.createdBy && !this.props.initiativeOwnerDetails._id) {
            dispatch.initiatives.getInitiativeOwnerDetails(this.props.selectedDataById.createdBy);
        }
    }
    componentWillMount() {
        dispatch.initiatives.setTabName("review");
        let selectedDataById = this.props.selectedDataById;
        let objValidation = Object.entries(selectedDataById).length === 0 && selectedDataById.constructor === Object
        if (objValidation) {
            dispatch.initiatives.getInDesignInitiativeDetailsById(this.props.match.params.initiativeId);
        }
        dispatch.initiatives.showResourecePane(null);
        dispatch.app.setRouteParams(this.props.match.params)
    }

    open = () => this.setState({ open: true })
    close = () => {
        this.setState({ open: false });
    }

    async startInitiative() {
        let obj = {
            "_id": this.props.selectedDataById._id,
            "totalActivityCount": activityCount,
            "organizationId": this.props.match.params.workspaceId,
            "accountId": this.props.match.params.accountId
        }
        await dispatch.initiatives.startInitiative(obj);

        if (!this.props.loadingStartInitiative) {
            this.setState({ open: true, msg: "kicked off" })
        }
    }

    editFinish = () => {
        this.setState({ open: true, msg: "edited" })
        let countsData = {
            "totalActivityCount": activityCount,
            "totalCompletedCount": totalCompletedCount,
            "totalInProgressCount": totalInProgressCount,
            "totalOnHoldCount": totalOnHoldCount,
            "totalIssueCount": totalIssueCount,
            "status": activityCount === totalCompletedCount ? 2 : 1
        }
        if (countsData.totalActivityCount == countsData.totalCompletedCount) {
            countsData.status = 2;
        } else {
            countsData.status = 1;
        }
        this.props.selectedDataById.countsData = countsData;
        dispatch.initiatives.restartInitiative(this.props.selectedDataById);
    }

    backClick() {
        const history = this.props.history;
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/indesign/finalize/' + this.props.match.params.initiativeId
        });
    }

    async deleteInitiative() {
        let initId = this.props.match.params.initiativeId;
        let payload = await Object.assign({}, this.props.selectedDataById);
        payload.initId = initId;
        let message = <div className="confirmMessage">
            <h3>Delete Initiative</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you wish to do this?</p>
            <span >This action is not reversible</span>
        </div>
        await toastr.confirm(message, {
            onOk: () => {
                dispatch.initiatives.removeInitiative(payload);
            }
        });
    }

    homePage = async () => {
        await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.match.params.initiativeId);
        let payload = {}
        payload.organizationId = this.props.selectedOrganisation.id
        payload.accountId = this.props.match.params.accountId
        dispatch.initiatives.getinitiativesCount(payload);
        const history = this.props.history;
        dispatch.initiatives.getInitiatives(payload);
        this.setState({ open: false })
        dispatch.initiatives.isSortingFlag(null);
        history.push({
            pathname: '/app/' + this.props.match.params.accountId + '/_ws/' + this.props.match.params.workspaceId + '/_in/active'
        });
        // dispatch.initiatives.initiativeAggangementPane("ActiveInitiativeTabs");
        dispatch.initiatives.splitAt("60%");

    }
    progressPage = async () => {
        await dispatch.initiatives.getActiveInitiativeDetailsById(this.props.match.params.initiativeId);
        let payload = {}
        payload.organizationId = this.props.selectedOrganisation.id
        payload.accountId = this.props.match.params.accountId
        dispatch.initiatives.getinitiativesCount(payload);
        dispatch.initiatives.setTreeCurrentPath("0/2");
        const history = this.props.history;
        dispatch.initiatives.getInitiatives(payload);
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in/start/active/Progress/${this.props.selectedDataById._id}`
        });
        this.setState({ open: false })
    }

    getTeam() {

        const teamObj = this.props.teamList && this.props.teamList.filter((team) => {
            return team.value === this.props.selectedDataById.teamId
        })

        return teamObj ? teamObj && teamObj[0] && teamObj[0].text : '';
    }
    pushUsers(activities, userList) {
        activities.map(activity => {
            if (activity.isLeafNode) {
                activityCount++;
            }
            if (activity.isLeafNode && activity.runStatus == 1) {
                totalInProgressCount++;
            }
            if (activity.isLeafNode && activity.runStatus == 2) {
                totalCompletedCount++;
            }
            if (activity.isLeafNode && activity.onHoldFlag == true) {
                totalOnHoldCount++;
            }
            if (activity.isLeafNode && activity.issueFlag == true) {
                totalIssueCount++;
            }
            if (activity.raci) {
                if (activity.raci.a && activity.raci.a.accountUserId) {
                    if (typeof activity.raci.a.accountUserId === 'object') {
                        userList.add(activity.raci.a.accountUserId._id);
                    }
                    else {
                        if (activity.raci.a.accountUserId) {
                            userList.add(activity.raci.a.accountUserId);
                        }
                    }
                }
                if (activity.raci.r) {
                    activity.raci.r.forEach(r => {
                        if (r.accountUserId) {
                            if (typeof r.accountUserId === 'object') {
                                userList.add(r.accountUserId._id);
                            }
                            else {
                                if (activity.raci.a.accountUserId) {
                                    userList.add(r.accountUserId);
                                }
                            }
                        }
                    })
                }
                if (activity.raci.c) {
                    activity.raci.c.forEach(c => {
                        if (c.accountUserId) {
                            if (typeof c.accountUserId === 'object') {
                                userList.add(c.accountUserId._id);
                            }
                            else {
                                if (activity.raci.a.accountUserId) {
                                    userList.add(c.accountUserId);
                                }
                            }
                        }
                    })
                }
                if (activity.raci.i) {
                    activity.raci.i.forEach(i => {
                        if (i.accountUserId) {
                            if (typeof i.accountUserId === 'object') {
                                userList.add(i.accountUserId._id);
                            }
                            else {
                                if (activity.raci.a.accountUserId) {
                                    userList.add(i.accountUserId);
                                }
                            }
                        }
                    })
                }
            }
            if (activity.activities && activity.activities.length > 0) {
                this.pushUsers(activity.activities, userList)
            }
        })
    }
    countUsers() {
        let usersList = new Set();
        activityCount = 0;
        totalCompletedCount = 0;
        totalInProgressCount = 0;
        totalIssueCount = 0;
        totalOnHoldCount = 0;
        this.pushUsers(this.props.selectedDataById.activities, usersList);
        return [...usersList].length
    }

    addDefaultSrc(ev) {
        ev.target.src = noImage
    }
    cancelEdit = () => {
        let message = <div className="confirmMessage">
            <h3>Cancel Editing</h3>
            <label>{this.props.selectedDataById.name}</label>
            <p>Are you sure that you want to Cancel editing this initiative?</p>
            <span >All the changes done until now will be lost.</span>
        </div>
        toastr.confirm(message, {
            okText: 'Cancel Editing',
            cancelText: 'Keep Editing',
            onOk: () => {
                dispatch.initiatives.cancelInitiativeEdit(this.props.selectedDataById);
            }
        });
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    brokenUserImage(ev) {
        ev.target.src = brokenUserImg
    }

    downloadAttachment = (attachment) => {
        attachment.accountId = this.props.selectedAccount._id;
        dispatch.app.downloadAttachment(attachment);
    }

    render() {
        const { activeIndex } = this.state

        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;
        return (
            <div ref={this.parentRef} style={{ width: "100%", maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>
                {this.props.loadingDataById ? <LoadingComponent message="Please wait..." active={this.props.loadingDataById} /> : null}
                <Grid className="containerBoxFullWidth">
                    <Grid.Row >
                        <BreadCrumbs {...this.props} />
                    </Grid.Row>
                    <Grid.Row >
                        <CreateInitiativeSteps {...this.props} setPage="review" />
                    </Grid.Row>
                    <Grid.Row >
                        <Grid className="review">
                            <Grid.Row >
                                <Grid className="w_100 finalize">
                                    <Grid.Row className="blocks">
                                        <Grid.Column width={6}>
                                            <Labels
                                                name="Initiative Name"
                                                text={this.props.selectedDataById.name} />
                                            <Labels
                                                name="Playbook Designer"
                                                text={
                                                    <List horizontal >
                                                        <List.Item>
                                                            <ImageAvater user={this.props.initiativeOwnerDetails} />
                                                            <div className="float-left f_11" style={{ padding: '3px 0' }}>
                                                                {this.props.initiativeOwnerDetails && this.props.initiativeOwnerDetails.firstName + ' ' + this.props.initiativeOwnerDetails.lastName}
                                                            </div>
                                                        </List.Item>
                                                    </List>
                                                }
                                            />
                                        </Grid.Column>
                                        <Grid.Column width={6}>
                                            {(this.props.selectedDataById.teamId && this.props.selectedDataById.teamId.toString() !== this.props.selectedOrganisation.id.toString()) ?
                                                <div>
                                                    <Labels
                                                        name="Initiative Execution"
                                                        text="Team Level" />
                                                    <Labels
                                                        name="Selected Team"
                                                        text={this.getTeam()} />
                                                </div>
                                                :
                                                <Labels
                                                    name="Initiative Execution"
                                                    text="Workspace Level" />
                                            }
                                        </Grid.Column>
                                        <Grid.Column width={4} >
                                            <Image
                                                onError={this.addDefaultSrc}
                                                src={this.props.selectedDataById.picture}
                                                style={{ objectFit: "cover", height: "100px", width: "180px" }} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    {this.props.selectedDataById && this.props.selectedDataById.metaData && Object.keys(this.props.selectedDataById.metaData).length !== 0 ?
                                        <Grid.Row className="blocks">
                                            <Grid.Column width={16}>
                                                <Accordion>
                                                    <Accordion.Title
                                                        active={activeIndex === 2}
                                                        index={2}
                                                        onClick={this.handleClick}
                                                    >
                                                        <Icon name='dropdown' />
                                                        Custom Attribute
                                                    </Accordion.Title>
                                                    <Accordion.Content active={activeIndex === 2}>
                                                        <MetaDatareadonlyView
                                                            metaData={this.props.selectedDataById.metaData}
                                                        />
                                                        {this.props.selectedDataById &&
                                                            this.props.selectedDataById.attachments &&
                                                            this.props.selectedDataById.attachments.length !== 0 ?
                                                            <Labels
                                                                name={"Attachments"}
                                                                text={
                                                                    <Card.Group style={{ "padding": "10px 0" }}>
                                                                        {this.props.selectedDataById.attachments.map((m, ind) => {
                                                                            return <Card
                                                                                onClick={() => { this.downloadAttachment(m) }}
                                                                                className="userListCard pad_5 attachedCard"
                                                                                title={m.documentName} >
                                                                                <Card.Content >
                                                                                    <Icon
                                                                                        name={extensionPreview(m.documentName)}
                                                                                        className="float-left clr-blue f_24 "
                                                                                        style={{ width: "30px", height: "18px" }}
                                                                                    />
                                                                                    <Card.Header style={{ padding: "3px 0" }}>
                                                                                        <EllipsisTooltip name={m.documentName} />
                                                                                    </Card.Header>
                                                                                </Card.Content>
                                                                            </Card>
                                                                        })}
                                                                    </Card.Group>
                                                                } /> : null}
                                                    </Accordion.Content>
                                                </Accordion>
                                            </Grid.Column>
                                        </Grid.Row> : null}

                                    <Grid.Row className="blocks">
                                        <Grid.Column width={16}>
                                            <Labels
                                                name="Description"
                                                text={this.props.selectedDataById.description === "" || this.props.selectedDataById.description === null ? "No Description Added" : this.props.selectedDataById.description}
                                                htmlView={true} />
                                        </Grid.Column>
                                    </Grid.Row>

                                    <Grid.Row className="blocks">

                                        <Grid.Column width={4}>
                                            <Grid >
                                                <Grid.Row >
                                                    <Labels
                                                        name="Start Date"
                                                        text={this.props.selectedDataById.startDate ? momentDateAndTime(this.props.selectedDataById.startDate) : "---"} />
                                                </Grid.Row>
                                                <Grid.Row >
                                                    <Labels
                                                        name="End Date"
                                                        text={this.props.selectedDataById.endDate ? momentDateAndTime(this.props.selectedDataById.endDate) : "---"} />

                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                        <Grid.Column width={7}>
                                            <Grid >
                                                <Grid.Row >
                                                    <Grid.Column width={8}>
                                                        <Labels
                                                            name="Total Days"
                                                            text={this.props.selectedDataById.totaldays ? this.props.selectedDataById.totaldays : "---"} />
                                                    </Grid.Column>
                                                    <Grid.Column width={8}>
                                                        <Labels
                                                            name="Contingency / Holidays"
                                                            text={this.props.selectedDataById.contingency && this.props.selectedDataById.contingency > 0 ? this.props.selectedDataById.contingency : 0} />
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row >
                                                    <Grid.Column width={16}>
                                                        <div className="days_buttons">
                                                            <Labels
                                                                name="Working Days"
                                                                text={
                                                                    <div className="days_buttons" >
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[0] ? "blue" : null} onClick={() => this.changeWorkingDay('Sunday')}>Su</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[1] ? "blue" : null} onClick={() => this.changeWorkingDay('Monday')}>Mo</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[2] ? "blue" : null} onClick={() => this.changeWorkingDay('Tuesday')}>Tu</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[3] ? "blue" : null} onClick={() => this.changeWorkingDay('Wednesday')}>We</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[4] ? "blue" : null} onClick={() => this.changeWorkingDay('Thursday')}>Th</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[5] ? "blue" : null} onClick={() => this.changeWorkingDay('Friday')}>Fr</Button>
                                                                        <Button size='mini' disabled color={this.props.selectedDataById && this.props.selectedDataById.workingDays && this.props.selectedDataById.workingDays[6] ? "blue" : null} onClick={() => this.changeWorkingDay('Saturday')}>Sa</Button>
                                                                    </div>
                                                                } />
                                                        </div>
                                                    </Grid.Column>
                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                        <Grid.Column width={5}>
                                            <Grid >
                                                <Grid.Row >
                                                    <Labels
                                                        name="Stats"
                                                        text={
                                                            <span>
                                                                <div style={{ 'margin': '7px 0' }}>
                                                                    <Icon name="sitemap" color="grey" />
                                                                    <span className="ui blue circular label cardLabel">
                                                                        {activityCount}
                                                                    </span>
                                                                    <span> Activities</span>
                                                                </div>
                                                                <div style={{ 'margin': '7px 0' }}>
                                                                    <Icon name="group" color="grey" />
                                                                    <span className="ui blue circular label cardLabel">
                                                                        {this.props.selectedDataById && this.props.selectedDataById.activities ? this.countUsers() : ''}
                                                                    </span>
                                                                    <span> Participants</span>
                                                                </div>
                                                            </span>
                                                        } />
                                                </Grid.Row>
                                            </Grid>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row className="blocks">
                                        <Grid.Column width={16}>
                                            {this.props.selectedDataById && <DailyUpdateCheckBox id={this.props.selectedDataById._id} dailyUpdates={this.props.selectedDataById.dailyUpdates} />}
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Grid.Row>


                            <Grid.Row>
                                <Grid.Column width={8} className="pad_0">
                                    {this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 4 ?
                                        <div className="bottom_button_set" >
                                            <Button
                                                className="button-cancel"
                                                onClick={() => this.backClick()} >Previous </Button>
                                        </div> :
                                        this.props.selectedDataById.status === 1 ?
                                            "" :
                                            this.props.selectedDataById.status === 2 ? "" : ""
                                    }
                                </Grid.Column >
                                <Grid.Column width={8} className="pad_0">
                                    {this.props.selectedDataById.status === 0 || this.props.selectedDataById.status === 4 ?
                                        <div className="bottom_button_set" style={{ textAlign: "right" }} >
                                            {this.props.selectedDataById.status === 4 && <Button
                                                type="button"
                                                className="button-cancel"
                                                onClick={() => this.cancelEdit()}>Cancel</Button>}

                                            {this.props.selectedDataById.status === 4 ?

                                                <Button
                                                    type='button'
                                                    id='next'
                                                    className="button-submit"
                                                    onClick={() => this.editFinish()} > Finish </Button>
                                                :
                                                <Button
                                                    type='button'
                                                    id='next'
                                                    className="button-submit"
                                                    onClick={() => this.startInitiative()} > Kick-off Initiative </Button>}

                                        </div> :
                                        this.props.selectedDataById.status === 1 || this.props.selectedDataById.status === 2 ?
                                            <div className="bottom_button_set" style={{ textAlign: "right" }} >
                                                <Button
                                                    icon='home'
                                                    className="button-submit"
                                                    content='Go to Initiatives '
                                                    onClick={this.homePage} />
                                                <Button
                                                    icon='list'
                                                    className="button-info"
                                                    content='View Progress'
                                                    onClick={this.progressPage} />
                                            </div> :
                                            this.props.selectedDataById.status === 2 ? "" : ""
                                    }
                                </Grid.Column >

                            </Grid.Row>
                            <Grid.Row>

                                {!this.props.loadingStartInitiative && (this.props.selectedDataById.status === 1 || this.props.selectedDataById.status === 2) ?
                                    <Modal
                                        open={this.state.open}
                                        onOpen={this.open}
                                        onClose={this.close}
                                        size='mini'
                                        className="filterModal basicModal"
                                        closeOnEscape={false}
                                        closeOnDimmerClick={false}
                                        closeIcon
                                    >
                                        {/* <Modal.Header>{this.props.selectedDataById.name}</Modal.Header> */}
                                        <Modal.Header style={{ position: 'relative', paddingRight: '40px' }}>
                                        <div style={{
                                            whiteSpace: 'normal', 
                                            overflow: 'hidden', 
                                            textOverflow: 'ellipsis', 
                                            wordWrap: 'break-word',
                                            maxWidth: 'calc(100% - 40px)'
                                           }}>
                                           {this.props.selectedDataById.name}
                                        </div>
                                        </Modal.Header>
                                        <Modal.Content>
                                            Congratulations! Initiative is {this.state.msg} successfully. <br /><br />
                                            You will see the working status of current initiative in <strong>Progress</strong>.
                                        </Modal.Content>
                                        <Modal.Actions>
                                            <Button icon='home' className="button-submit" content='Go to Initiatives ' onClick={this.homePage} />
                                            <Button icon='list' className="button-info" content='View Progress' onClick={this.progressPage} />
                                        </Modal.Actions>
                                    </Modal> : ""
                                }
                            </Grid.Row>
                        </Grid>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default withRouter(ReviewAndStart);
